module.exports = __webpack_public_path__ + "static/media/apple-store-pt.8fd45f10.svg";